import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { type IPractice } from '@principle-theorem/principle-core/interfaces';
import { type WithRef } from '@principle-theorem/shared';
import { ReplaySubject } from 'rxjs';

@Component({
  selector: 'pr-practice-verifone-settings',
  templateUrl: './practice-verifone-settings.component.html',
  styleUrls: ['./practice-verifone-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PracticeVerifoneSettingsComponent {
  practice$ = new ReplaySubject<WithRef<IPractice>>(1);

  @Input()
  set practice(practice: WithRef<IPractice>) {
    if (practice) {
      this.practice$.next(practice);
    }
  }
}
